export class RequestCardModel {
    consumer = new ConsumerDetails();
    travel = new TravelDetails();
    transactionDetails = new TransactionDetails();
    buySellDetails = new BuySellDetails();
    paymentDetails = new PaymentDetails()
    cardDetails = new CardDetails()
}

export class ConsumerDetails {
    firstName: string;
    middlelName: string;
    lastName: string;
    gender: string;
    mobile: string;
    mobileCountryCode: "+91";
    email: string;
    address: string;
    city: string;
    pin: string;
    state: string;
    country: string;
    pan: string;
    passport: string;
    dob: string;
    politicallyExposed: string;
    entityType: string;
    corporateName: string;
}

export class TravelDetails {
    country: string;
    countryCode: string;
    startDate: string;
    endDate: string;
    travellerPan: string;
    travellerDob: string;
    travellerName: string;
}

export class TransactionDetails {
    transactionId: string;
    documentId: string;
    branchCode: string;
    dateTime: string;
    product: string;
    purpose: string;
    rbiPurpose: string;
}

export class BuySellDetails {
    currencyCode: string;
    currencyAmount: string;
    equvalentUsdAmount: string;
    saleRate: string;
    transactionAmount: string;
}

export class PaymentDetails {
    paymentStatus: string;
    sourceOfFund: string;
    payerName: string;
    payerRelation: string;
}

export class CardDetails {
    operation: string;
    kitId: string;
    replacementKitId: string;
    issuer: string;
    plasticCode: string;
    chargeCode: string;
}


// WEBPACK FOOTER //
// ./src/app/_models/card/cardModel.ts